import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalComponent } from 'src/app/global/global.component';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { RolesService } from './roles.service';
import { ToastrService } from 'ngx-toastr';
import { ErrorService } from 'src/app/error.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import {
  MenuFunctionalityRolePermissionBO,
  PermissionUpdationBO,
  RolePermissionBO,
  SideMenuRolePermissionBO,
} from './roles.model';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.scss'],
})

export class RolesComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  RoleType: string = "";

  header: any = [];
  isSaveUrUpdateBoolean: boolean = false;
  isInternalRole: boolean = false;
  isSuperAdmin: boolean = false;
  headerName: any = "";
  editField: string;
  masterSelected: boolean;
  checklist: any;
  rolesdata: Array<RolePermissionBO> = [];
  changeEnableData = [];
  form: FormGroup;
  menuData = [];
  roleAlerts: any = "";
  rolePermisssionList: any;
  selectAll: boolean = false;
  role = new FormControl('', Validators.required);
  roletobeDeleted: string = null;
  isSaveClicked: boolean;

  constructor(private router: Router, public global: GlobalComponent,
    public rolesService: RolesService, public toastr: ToastrService,
    public errorService: ErrorService) {
    this.global.checkforlogout();
    this.masterSelected = false;
  }

  ngOnInit(): void {
    if (this.global.agencyCode.toUpperCase() == 'SUPERADMIN' && (this.global.globalAgencyId == '00000000-0000-0000-0000-000000000000' ||
      this.global.globalAgencyId == null || this.global.globalAgencyId == '')) {
      this.RoleType = "SuperAdminRole";
    } else if (this.global.agencyCode.toUpperCase() == 'SUPERADMIN' && (this.global.globalAgencyId != '00000000-0000-0000-0000-000000000000' &&
      this.global.globalAgencyId != null && this.global.globalAgencyId != '')) {
      this.RoleType = "Internal";
    }
    else if (this.global.agencyCode.toUpperCase() != 'SUPERADMIN') {
      this.RoleType = "Internal";
    }
    this.RoleTypeChange()
    this.getHeaderRole();
  }
  rolePermissions = [
    {
      RoleName: 'R1',
      HasAllPermission: true,
      MenuPermissions: [
        {
          MenuName: 'Client',
          HasPermisison: true,
          FunctionPermissions: [
            {
              FunctionName: 'Create',
              HasPermisison: true,
            },
            {
              FunctionName: 'Delete',
              HasPermisison: true,
            },
          ],
          SubMenuPermissions: [
            {
              MenuName: 'Client',
              HasPermisison: true,
              FunctionPermissions: [
                {
                  FunctionName: 'Create',
                  HasPermisison: false,
                },
              ],
            },
          ],
        },
        {
          MenuName: 'ClientOnboard',
          HasPermisison: true,
          FunctionPermissions: [
            {
              FunctionName: 'Create',
              HasPermisison: true,
            },
            {
              FunctionName: 'Delete',
              HasPermisison: true,
            },
          ],
        },
      ],
    },
    {
      RoleName: 'R2',
      HasAllPermission: false,
      MenuPermissions: [
        {
          MenuName: 'Client',
          HasPermisison: true,
          FunctionPermissions: [
            {
              FunctionName: 'Create',
              HasPermisison: true,
            },
          ],
        },
      ],
    },
  ];

  saveRole() {
    this.isSaveClicked = true;
    this.rolesService.saveRoleData(this.changeEnableData).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastr.success('Roles updated Successfully!');
      this.isSaveClicked = false;
    },
      err => {
        this.isSaveClicked = false;
      })
  }

  SaveMenuFuncPermission(item) {
    if (item.menuFunctionalityId != null && item.menuFunctionalityId != '' && item.menuFunctionalityId != undefined) {
      let functionalityData: MenuFunctionalityRolePermissionBO = new MenuFunctionalityRolePermissionBO()
      functionalityData.loginRoleId = item.loginRoleId
      functionalityData.menuFunctionalityId = item.menuFunctionalityId
      functionalityData.hasPermission = item.isEnabled
      this.rolesService.saveMenuFuncPermission(functionalityData).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.getHeaderRole();
        this.global.loading = false;
      },
        (err: any) => {
          this.toastr.error(err)
        })
    }
    else {
      let sidemenuData: SideMenuRolePermissionBO = new SideMenuRolePermissionBO()
      sidemenuData.loginRoleId = item.loginRoleId
      sidemenuData.hasPermission = item.isEnabled
      sidemenuData.sideMenuId = item.menuItemsId
      this.rolesService.saveRoleData(sidemenuData).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.getHeaderRole();
        this.global.loading = false;
      },
        (err: any) => {
          this.toastr.error(err)
        })
    }
  }
  //.......................................................save Role and permissions...................................................//
  saveRoleandPermissions(saveData, menuPermission) {
    saveData.isEvv = this.isInternalRole;
    this.global.loading = true;
    let sidemenuData: SideMenuRolePermissionBO = new SideMenuRolePermissionBO()
    sidemenuData.loginRoleId = saveData.roleId
    sidemenuData.hasPermission = menuPermission.hasPermisison
    sidemenuData.sideMenuId = menuPermission.menuId
    this.rolesService.saveRoleData(sidemenuData).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getHeaderRole();
      this.global.loading = false;
    },
      (err: HttpErrorResponse) => {
      })
  }
  addRole(item) {
    this.header.push({ th: item });
    this.rolesService.sendGetRequest().pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
    })
  }
  Addrole() {
    this.headerName = "";
  }
  //================================================save Role and permissions=======//
  SaveRoleBasedMenu(Role) {
    this.global.loading = true;
    let sendData: PermissionUpdationBO = new PermissionUpdationBO();

    sendData.loginRoleId = Role.roleId;
    sendData.isEnabled = Role.isRoleEnabled;
    this.rolesService.SaveRoleBasedMenuNew(sendData).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getHeaderRole();
      this.global.loading = false;
    },
      (err: HttpErrorResponse) => {

      }
    )
  }
  //================================================save Role and permissions=======//
  SaveAllMenuRoles(isEnabled) {

  }

  updateList(id: number, property: string, event: any) {
    const editField = event.target.textContent;
    this.header[id][property] = editField;
  }

  changeValue(id: number, property: string, event: any) {
    this.editField = event.target.textContent;
  }

  roleMap() {
    this.router.navigate(['/role-map'])
  }

  ////////===============New Role Fun==============================////////////////////////
  addroles(headerName) {
    this.isSaveUrUpdateBoolean=true;
    let url = "api/LoginRole/saveRole";
    let obj = {
      RoleId: headerName,
      RoleName: headerName,
      AgencyId: this.global.globalAgencyId,
      isInternal: this.isInternalRole,
      isAdminPermission: true,
      isSuperAdmin: this.isSuperAdmin
    };
    this.rolesService.newRole(obj).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.isSaveUrUpdateBoolean=false;
      this.getHeaderRole();
      document.getElementById('OpenModal2').click();
      var tbl = document.getElementsByTagName("body")[0];
      var tr = tbl.getElementsByTagName("tr");
      for (var i = 0; i < tr.length; i++) {
        var td = document.createElement('td');
        td.style.padding = "7px";
        td.style.borderBottom = "2px solid #ddd";
        td.style.textAlign = "center";
        td.style.border = "0px";
        tr[i].appendChild(td);
      }
      this.toastr.success("Role created successfully!");
      setTimeout(() => {
        this.toastr.clear();
      }, 8000);
    },
      (err: HttpErrorResponse) => {
        this.isSaveUrUpdateBoolean=false;
        if (err) {
          let response: any = err;
          this.toastr.error(response, 'Error'), 8000;
        }
      })
  }
  rolePermissionMappingData: any
  //......................................................getHeaderRole..........................................................
  getHeaderRole() {

    let param = new URLSearchParams();

    param.append("isInternal", this.isInternalRole.toString());
    param.append("isSuperAdmin", this.isSuperAdmin.toString());
    this.rolesService.getheaderrole(param).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.rolePermisssionList = data[0];

    },
      (err: HttpErrorResponse) => {
        this.roleAlerts = "";
        this.roleAlerts = err.error;
        if (this.roleAlerts != "") {
          setTimeout(function () {
            this.roleAlerts = "";
          }.bind(this), 8000);
        }
      });
  }
  switchchange() {
    this.getHeaderRole();
  }
  //.......................................................deleteRole...........................................................
  deleteRoleSelected(args) {
    this.roletobeDeleted = args.roleId;
  }

  deleteRole() {
    this.rolesService.deleteRole(this.roletobeDeleted).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.getHeaderRole();
      document.getElementById('deleterolemodalopen').click();
      this.toastr.success("Role deleted successfully!");
      this.roletobeDeleted = null
      setTimeout(() => {
        this.toastr.clear();
      }, 8000);
    },
      (err: HttpErrorResponse) => {
        if (err) {
          let response: any = err;
          this.toastr.error(response, 'Error'), 8000;
        }
      })
  }
  //......................................................RoleTypeChange.........................................................
  RoleTypeChange() {

    if (this.RoleType == "SuperAdminRole") {
      this.isSuperAdmin = true;
      this.isInternalRole = false;
    }
    else if (this.RoleType == "Agencyadmin") {
      this.isInternalRole = false;
      this.isSuperAdmin = false;
    }

    else if (this.RoleType == "Global") {
      this.isInternalRole = false;
      this.isSuperAdmin = false;
    }

    else if (this.RoleType == "Internal") {
      this.isInternalRole = true;
      this.isSuperAdmin = false;
    }
    this.getHeaderRole();
  }
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

}
